import { Observable } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/internal/operators';
import { default as CognitoUserAuthenticator } from './CognitoUserAuthenticator';
import UserLogoutRequested from '../events/UserLogoutRequested';
import UserLogoutCompleted from '../events/UserLogoutCompleted';

export default (event$: Observable<Event>): Observable<Event> =>
    event$.pipe(
        ofType(UserLogoutRequested.type),
        mergeMap(() => {
            return CognitoUserAuthenticator.logout().pipe(
                map(() => {
                    return new UserLogoutCompleted();
                })
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/user/epic/logoutUser.ts